import styled from 'styled-components';
import { Dispatch, SetStateAction, useEffect, useRef } from 'react';

interface PopupModalProps {
  isOpenModal: boolean;
  setIsOpenModal: Dispatch<SetStateAction<boolean>>;
  message: string;
  needsCancelBtn: boolean;
  confirmFn?: Function;
}

const PopupModal = (props: PopupModalProps) => {
  const { isOpenModal, setIsOpenModal, message, needsCancelBtn, confirmFn } = props;

  const Item = (msg: string) => {
    return (
      <>
        {msg.split(',').map((txt: string) => (
          <>
            {txt}
            <br />
          </>
        ))}
      </>
    );
  };

  return (
    <>
      {isOpenModal === true ? (
        <>
          <DimModalContainer>
            <BackgroundDim></BackgroundDim>
            <ModalDiv>
              <ModalTitle className="b2">{Item(message)}</ModalTitle>
              <ModalBtnWrap>
                <ModalBtn
                  isConfirmButtonStyle={true}
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsOpenModal(false);
                    confirmFn && confirmFn();
                  }}
                >
                  확인
                </ModalBtn>
                {/* 취소 필요한 경우에만 사용! */}
                {needsCancelBtn && (
                  <>
                    <ModalBtn
                      isConfirmButtonStyle={false}
                      onClick={(e) => {
                        e.stopPropagation();
                        setIsOpenModal(false);
                      }}
                    >
                      취소
                    </ModalBtn>
                  </>
                )}
              </ModalBtnWrap>
            </ModalDiv>
          </DimModalContainer>
        </>
      ) : (
        <></>
      )}
    </>
  );
};
export default PopupModal;

const DimModalContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
`;

const BackgroundDim = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0.7;
  background: var(--neutral-gray-900);
`;

const ModalDiv = styled.div`
  width: 32.5rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 2.5rem;

  z-index: 99;

  border-radius: 1rem;
  background: var(--neutral-white);
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.25);
`;

const ModalTitle = styled.p`
  width: 100%;
  color: var(--neutral-gray-800);
  line-height: 160%;
`;

const ModalBtnWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

const ModalBtn = styled.button<{ isConfirmButtonStyle: boolean }>`
  color: ${(props) =>
    props.isConfirmButtonStyle ? 'var(--primary-ivy-green-600)' : 'var(--neutral-gray-600)'};
  background-color: transparent;
  font-family: Pretendard;
  font-size: 1.6rem;
  font-style: normal;
  font-weight: 700;
  line-height: 2rem; /* 125% */
  letter-spacing: 0.0016rem;
  text-decoration-line: underline;
`;
